<nav class="cc-navigation" [ngClass]="{ 'is-ready-to-display': isReadyToDisplay }">
  <div class="cc-navigation__container" #navigationContainer [ngClass]="{ 'is-open': isOpen }">
    <!-- MOBILE -->
    <!-- MBCC-724: cc-navigation__mobile is used for height measurement and referenced in global-constants.ts -->
    <div class="cc-navigation__mobile">
      <div class="cc-navigation__mobile-wrapper cc-grid-container">
        <ng-container
          *ngTemplateOutlet="
            mobileNavigationButton;
            context: {
              hideLabel: currentIndex < 1,
              buttonIndex: currentIndex - 1,
              isNextButton: false
            }
          "
        />
        <ng-container *ngTemplateOutlet="mobileToggleButton; context: { currentIndex: currentIndex }" />
        <ng-container
          *ngTemplateOutlet="
            mobileNavigationButton;
            context: {
              hideLabel: currentIndex === (flatItems?.length || 0) - 1,
              buttonIndex: currentIndex + 1,
              isNextButton: true
            }
          "
        />
      </div>
    </div>

    <!-- DROPDOWN / DESKTOP -->
    <ul class="cc-navigation__navigation-list">
      @for (group of items; track group; let groupLast = $last) {
        @let isCurrentGroup = group.id === currentGroup.id;
        <li [ngClass]="{ 'is-current-group': isCurrentGroup }">
          <!-- with GROUP LABEL -->
          @if (group.name) {
            <ng-container
              *ngTemplateOutlet="
                navigationItem;
                context: {
                  item: group,
                  isLink: false,
                  isItem: false,
                  isGroup: true,
                  showIcon: false
                }
              "
            />
            <ul class="cc-navigation__group-list">
              @for (child of group.children; track child) {
                <li class="cc-navigation__item">
                  <ng-container
                    *ngTemplateOutlet="
                      navigationItem;
                      context: {
                        item: child,
                        isLink: true,
                        isItem: false,
                        isGroup: false,
                        showIcon: true
                      }
                    "
                  />
                </li>
              }
            </ul>
          } @else {
            <!-- without GROUP-LEVEL; Children at 1st level instead of 2nd -->
            @for (child of group.children; track child) {
              <ng-container
                *ngTemplateOutlet="
                  navigationItem;
                  context: {
                    item: child,
                    groupLast: groupLast,
                    isLink: true,
                    isItem: true,
                    isGroup: false,
                    showIcon: true
                  }
                "
              />
            }
          }
        </li>
      }
    </ul>
  </div>
</nav>

<ng-template #mobileToggleButton let-currentIndex="currentIndex">
  <button class="cc-navigation__mobile-content" #mobileToggle (click)="toggleDropdown(!isOpen)">
    <ng-container
      *ngTemplateOutlet="navigationText; context: { item: flatItems[currentIndex]?.child, showIcon: false }"
    />
    <ccwb-text size="m">
      {{ 'common.menu' | translate }}
      <ccwb-icon class="content-icon" [name]="isOpen ? 'chevron-up' : 'chevron-down'" />
    </ccwb-text>
  </button>
</ng-template>

<ng-template
  #mobileNavigationButton
  let-hideLabel="hideLabel"
  let-buttonIndex="buttonIndex"
  let-isNextButton="isNextButton"
>
  <ccwb-round-button
    class="cc-navigation__mobile-button"
    [class.cc-navigation__mobile-button--hidden]="hideLabel"
    [button-aria-label]="isNextButton ? 'Next Button' : 'Previous Button'"
    (click)="navigateToIndex(buttonIndex)"
    size="s"
  >
    <ccwb-icon [name]="isNextButton ? 'chevron-right' : 'chevron-left'" aria-hidden="true" />
  </ccwb-round-button>
</ng-template>

<ng-template
  #navigationItem
  let-item="item"
  let-groupLast="groupLast"
  let-isGroup="isGroup"
  let-isItem="isItem"
  let-isLink="isLink"
  let-showIcon="showIcon"
>
  @let isActiveItem = item.id === currentItem.id;
  @let isSingleChoice = item.categoryViewType === categoryViewType.SingleChoice;
  @let navItem = item?.children?.[0] ?? item;
  @let routerLink = getRouterLink$(navItem) | async;
  <button
    class="cc-navigation__button"
    [ngClass]="{
      'is-active': isActiveItem,
      'is-single-choice': isSingleChoice,
      'cc-navigation__item': isItem,
      'cc-navigation__group': isGroup,
      'cc-navigation__link': isLink
    }"
    [attr.navigation-menu-item-data-id]="routerLink"
    (click)="onNavigate(navItem, routerLink)"
    (keydown.escape)="toggleDropdownAndChangeFocus()"
    (keydown.tab)="groupLast ? toggleDropdown(false) : null"
  >
    <ng-container *ngTemplateOutlet="navigationText; context: { item: item, showIcon: showIcon }" />
  </button>
</ng-template>

<ng-template #navigationText let-item="item" let-showIcon="showIcon">
  <ccwb-text class="cc-navigation-group-text" size="l">
    {{ item.isTranslated ? (item.name | translate) : item.name }}
  </ccwb-text>
  @if (showIcon) {
    <ccwb-icon class="icon" name="chevron-right" />
  }
</ng-template>
